import { applyMiddleware, compose, createStore } from "redux";
import thunkMiddleware from "redux-thunk";
import asyncQueueMiddleware from "redux-async-queue";
import rootReducer from "./reducers";
import ReduxQuerySync from "redux-query-sync";
import reduxCookiesMiddleware, { getStateFromCookies } from "redux-cookies-middleware";
import { shareLink } from "./actions/index";
import Cookies from "js-cookie";
import ReactGA from "react-ga4";
import windowManager from "./windowManager";

// state to persist in cookies
let firstSessionCheck = true;
const cookiePaths = {
    userPreferences: {
        name: "aivr_preferences",
    },
    customAnnotationLabels: {
        name: "customAnnotationLabels",
    },
    requestedDesktop: {
        name: "requested_desktop",
    },
    "issues.filters.group": {
        name: "aivr_issue_filter_group",
    },
    "issues.filters.status": {
        name: "aivr_issue_filter_status",
    },
    "issues.filters.priority": {
        name: "aivr_issue_filter_priority",
    },
};

// We dont want to read access tokens from cookie when in sidekick
if (!window.location.pathname.startsWith("/widget")) {
    cookiePaths["access_token"] = {
        name: "workspace_key",
        equalityCheck: (a, b) => {
            if (a !== b) {
                return false;
            } else if (b && firstSessionCheck) {
                firstSessionCheck = false;
                return false;
            } else {
                return true;
            }
        },
    };
}

const setCookie = (name, value) => {
    Cookies.set(name, value, { secure: true, sameSite: "Strict" });
};

const cookieOptions = {
    setCookie,
};

function configureStore(preloadedState) {
    const middlewares = [windowManager, thunkMiddleware, asyncQueueMiddleware, reduxCookiesMiddleware(cookiePaths, cookieOptions)];
    const middlewareEnhancer = applyMiddleware(...middlewares);

    ReactGA.initialize([
        {
            trackingId: "G-TXK832S725",
            gaOptions: {
                siteSpeedSampleRate: 100,
            },
        },
    ]);

    ReactGA.send({ hitType: "pageview" });

    const storeEnhancer = ReduxQuerySync.enhancer({
        params: {
            share: {
                selector: (state) => state.shareLink,
                action: shareLink,
                defaultValue: null,
            },
        },
        initialTruth: "location",
        replaceState: true,
    });

    // Note
    // This is used to stop redux devtools crashing when the redux store tries to display large objects.
    // Add keys to the whitelist if you would like to view them in the extension
    const devToolsConfiguration = {
        stateSanitizer: (state) => {
            const newState = {};
            const whitelistItems = ["admin", "widgetData", "dashboardWidgetKey", "playlist", "railInspection"];
            Object.keys(state).forEach((key) => {
                if (!whitelistItems.includes(key)) {
                    newState[key] = "<<LONG_BLOB>>";
                } else {
                    newState[key] = state[key];
                }
            });

            return newState;
        },
    };

    const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__(devToolsConfiguration) : compose;

    const enhancers = [storeEnhancer, middlewareEnhancer];
    const composedEnhancers = composeEnhancers(...enhancers);
    return createStore(rootReducer, preloadedState, composedEnhancers);
}

const cookieState = getStateFromCookies(
    {
        userPreferences: {
            thermalHistory: false,
        },
    },
    cookiePaths,
);

const store = configureStore({
    ...cookieState,
});

store.dispatch({ type: "__INIT__" });

export default store;
